import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import MdCheck from "react-icons/lib/md/check";
import MdClear from "react-icons/lib/md/clear";

const renderStat = (value, statsLoaded) => {
  if (!statsLoaded) return <span className="text-muted">--</span>;
  return value ?? 0;
};

const renderStatBool = (value, statsLoaded) => {
  if (!statsLoaded) return <span className="text-muted">--</span>;
  return value ? (
    <MdCheck color="green" size={16} />
  ) : (
    <MdClear color="red" size={16} />
  );
};

const CompanyTableRow = ({
  visibleColumns,
  id,
  company_name,
  patients = {},
  orders = {},
  contacts = {},
  walk_in_orders,
  active,
  team_name,
  isS3User,
  manages_compliance,
  statsLoaded
}) => (
  <tr>
    <td>
      <Link to={`/companies/${id}/profile`}>{company_name}</Link>
    </td>
    {isS3User && visibleColumns["Team Name"] && <td>{team_name}</td>}
    {visibleColumns["Company Active"] && (
      <td>
        {active ? (
          <MdCheck color="green" size={16} />
        ) : (
          <MdClear color="red" size={16} />
        )}
      </td>
    )}
    {visibleColumns["Walk In Orders"] && (
      <td>{renderStat(walk_in_orders, statsLoaded)}</td>
    )}
    {visibleColumns["Total Orders"] && (
      <td>{renderStat(orders.count, statsLoaded)}</td>
    )}
    {visibleColumns["Patient Insights"] && (
      <React.Fragment>
        <td className="patient-insights-column">
          {renderStat(patients.active, statsLoaded)}
        </td>
        <td>{renderStat(patients.on_hold, statsLoaded)}</td>
        <td>{renderStat(patients.inactive, statsLoaded)}</td>
        <td>{renderStat(patients.eligible, statsLoaded)}</td>
      </React.Fragment>
    )}
    {visibleColumns["Order Statuses"] && (
      <React.Fragment>
        <td className="order-insights-column">
          {renderStat(orders.new_count, statsLoaded)}
        </td>
        <td>{renderStat(orders.ready_for_review_count, statsLoaded)}</td>
        <td>{renderStat(orders.pending_buildout_count, statsLoaded)}</td>
        <td>{renderStat(orders.pending_count, statsLoaded)}</td>
        <td>{renderStat(orders.coach_followup_count, statsLoaded)}</td>
        <td>{renderStat(orders.internal_coach_followup_count, statsLoaded)}</td>
        <td>{renderStat(orders.on_hold_count, statsLoaded)}</td>
        <td>{renderStat(orders.location_assistance_needed_count, statsLoaded)}</td>
        <td>{renderStat(orders.integration_follow_up_count, statsLoaded)}</td>
        <td>{renderStat(orders.sent_to_fulfillment_count, statsLoaded)}</td>
        <td>{renderStat(orders.pending_shipment_count, statsLoaded)}</td>
        <td>{renderStat(orders.backordered_count, statsLoaded)}</td>
        <td>{renderStat(orders.accepted_count, statsLoaded)}</td>
        <td>{renderStat(orders.completed_count, statsLoaded)}</td>
        <td>{renderStat(orders.rejected_count, statsLoaded)}</td>
        <td>{renderStat(orders.incorrect_count, statsLoaded)}</td>
        <td>{renderStat(orders.internal_processing_count, statsLoaded)}</td>
      </React.Fragment>
    )}
    {visibleColumns["Contact Insights"] && (
      <React.Fragment>
        <td className="contact-insights-column">
          {renderStat(contacts.Total_Success_Outbound_calls, statsLoaded)}
        </td>
        <td>{renderStat(contacts.Total_Success_Inbound_call, statsLoaded)}</td>
        <td>{renderStat(contacts.Total_Success_Agent_call, statsLoaded)}</td>
        <td>{renderStat(contacts.Total_Success_Agent_Voicemail, statsLoaded)}</td>
        <td>{renderStat(contacts.Total_Success_Email_Resupply_Request, statsLoaded)}</td>
        <td>{renderStat(contacts.Total_Success_Text_messages, statsLoaded)}</td>
        <td>{renderStat(contacts.Total_Success_Push_Notifications, statsLoaded)}</td>
      </React.Fragment>
    )}
    {visibleColumns["Manages Compliance"] && (
      <td>{renderStatBool(manages_compliance, statsLoaded)}</td>
    )}
  </tr>
);

export default CompanyTableRow;

CompanyTableRow.propTypes = {
  id: PropTypes.string.isRequired,
  company_name: PropTypes.string.isRequired,
  patients: PropTypes.object,
  orders: PropTypes.object,
  contacts: PropTypes.object,
  walk_in_orders: PropTypes.number,
  active: PropTypes.bool.isRequired,
  team_name: PropTypes.string,
  visibleColumns: PropTypes.shape({
    "Total Orders": PropTypes.bool,
    "Walk In Orders": PropTypes.bool,
    "Team Name": PropTypes.bool,
    "Patient Insights": PropTypes.bool,
    "Company Active": PropTypes.bool,
    "Order Statuses": PropTypes.bool,
    "Contact Insights": PropTypes.bool,
    "Manages Compliance": PropTypes.bool
  }),
  isS3User: PropTypes.bool.isRequired,
  manages_compliance: PropTypes.bool,
  statsLoaded: PropTypes.bool.isRequired
};
